<template>
  <div ref="observer" class="infinite-loading">
    <div v-if="loading" class="loading">
      <v-progress-circular indeterminate color="primary" :size="24"></v-progress-circular>
      <span class="ml-2">Loading...</span>
    </div>
    <div v-else-if="noMore" class="no-more">
      <span>No more items</span>
    </div>
    <div v-else-if="noResults" class="no-results">
      <span>No results found</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfiniteLoading',
  props: {
    identifier: {
      type: [String, Number],
      default: null
    },
    distance: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      loading: false,
      noMore: false,
      noResults: false,
      observer: null
    }
  },
  mounted() {
    this.setupIntersectionObserver()
  },
  beforeUnmount() {
    if (this.observer && typeof this.observer.disconnect === 'function') {
      this.observer.disconnect()
    }
  },
  watch: {
    identifier() {
      this.reset()
    }
  },
  methods: {
    setupIntersectionObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries || !Array.isArray(entries) || entries.length === 0) {
            return;
          }
          const entry = entries[0];
          if (entry && entry.isIntersecting && !this.loading && !this.noMore && !this.noResults) {
            this.triggerLoad()
          }
        },
        {
          rootMargin: `${this.distance}px`
        }
      )
      
      if (this.$refs.observer && this.observer) {
        this.observer.observe(this.$refs.observer)
      }
    },
    
    triggerLoad() {
      this.loading = true
      this.$emit('infinite', {
        loaded: () => {
          this.loading = false
        },
        complete: () => {
          this.loading = false
          this.noMore = true
        },
        error: () => {
          this.loading = false
        }
      })
    },
    
    reset() {
      this.loading = false
      this.noMore = false
      this.noResults = false
    }
  }
}
</script>

<style scoped>
.infinite-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  min-height: 60px;
}

.loading, .no-more, .no-results {
  display: flex;
  align-items: center;
  color: var(--theme-text-secondary);
  font-size: 14px;
}
</style> 